<template>
  <div class="exam_detail_box">
    <div class="bg_box">
    </div>
      <div class="exam_detail_top">
        <div class="exam_msg_t">
          <p class="exam_msg_tl">{{examinfoData.title}}</p>
          <!-- <div class="exam_msg_tr">
            <span>提醒</span>
            <van-switch 
              :value="remindChecked" 
              @input="remindChange"
              active-color="#44DB5E"
              size="28px"
            />
          </div> -->
        </div>
        <div class="exam_msg_b">
          <p v-if="examinfoData.startTime||examinfoData.endTime">报名时间：{{examinfoData.startTime.substring(0,16)=='1970-01-01 08:00'? '不详' : examinfoData.startTime.substring(0,16)}}~{{examinfoData.endTime.substring(0,16)=='1970-01-01 08:00'? '不详' : examinfoData.endTime.substring(0,16)}}</p>
          <p v-if="examinfoData.doTime">考试时间：{{examinfoData.doTime.substring(0,16)=='1970-01-01 08:00'? '不详' : examinfoData.doTime.substring(0,16)}}</p>
          <p v-if="examinfoData.checkTime">查询时间：{{examinfoData.checkTime.substring(0,16)=='1970-01-01 08:00'? '不详' : examinfoData.checkTime.substring(0,16)}}</p>
          <p v-if="examinfoData.isRemind">提醒方式：{{examinfoData.remindType}}</p>
        </div>
        <!-- <div class="exam_msg_link" v-if="!examinfoData.isRemind"><a @click="remindcheck()">加入我的日历</a></div>
        <div class="exam_msg_link" v-else><a @click="delremindcheck(examinfoData.id)">取消加入我的日历</a></div> -->
      </div>
      <div class="detail_info_box" v-html="examinfoData.content"></div>
      <tab-bar :current-index="1" />
      <!-- <van-popup 
      v-model="remindPop" 
      round 
      position="bottom" 
      :style="{ height: '30%' }"
      :close-on-click-overlay="false"
      >
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="remindPop = false"
          @confirm="remindChoose"
          title="提醒设置"
          
        />
      </van-popup> -->
  </div>
</template>
<script type="text/ecmascript-6">
import {
  Image as VanImage,
  Tab as VanTab,
  Tabs as VanTabs,
  Switch as VanSwitch,
  Button as VanButton,
  ImagePreview as VanImagePreview,
  Popup as VanPopup,
  Picker as VanPicker,
  Dialog as VanDialog,
  List as VanList,
  Toast
} from 'vant';
import Vue from "vue";
import API from "../api";
import axios from "axios";
import qs from 'qs';
import TabBar from '../components/tabbar.vue';
// import { Message } from 'element-ui'

export default {
  name: "",
  components: {
    TabBar,
   VanImage,
   VanTab,
   VanTabs,
   VanSwitch,
   VanButton,
   VanImagePreview,
   VanPopup,
   VanPicker,
   VanDialog,
   VanList,
  },
  data() {
    return {
      username: "",
      remindChecked:false,
      isRemind:true,
      active:0,
      ksjsTab:0,
      xgzlTab:0,
      toDay:'',
      examinfoData:{},
      remindPop:false,
      columns:[{ text: '前1小时', value: 4 },{ text: '前1天', value: 3 },{ text: '前2天', value: 2 },{ text: '前3天', value: 1 }],
      remindType:0,
      infoTypeData:{},
      infoTypesData:{},
      typeact:0,
      typesact:0,
      fid: 1,
      page:1,
      examid:this.$route.params.id,
      size:15,
      typeid:0,
      list: [],
      loading: false,
      finished: false,
      listData:{},
    };
  },
  mounted() {
   this.getCalendarDetail();
  //  this.getInfoType();
  //  this.getInfosType();
  //  this.getDataList();
  //  this.getTrendsList();
  },
  
  methods: {
    async getUserInfo(){ //用户信息
      const res = await API.getUserInfo();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.userData = res.data.data;
        // console.log(this.userData)
        //console.log(res.data.data.data1)
      } else {
        Toast(res.data.message);
      }
    },
    async getCalendarDetail(){ //考试信息
      const params = {
        id: this.$route.params.id
      };
      const res = await API.getCalendarDetail(params);
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.examinfoData = res.data.data;
        // console.log(this.examinfoData)
        //console.log(res.data.data.data1)
      } else {
        Toast(res.data.message);
      }
    },
    async getInfoType(){ 
      const res = await API.getInfoType();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.infoTypeData = res.data.data;
        
        // console.log(this.userData)
        //console.log(res.data.data.data1)
      } else {
        Toast(res.data.message);
      }
    },
    async getInfosType(fid){ 
      const params = {
        fid: this.fid
      };
      const res = await API.getInfoType(params);
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.infoTypesData = res.data.data;
        this.typeid=this.infoTypesData[0].id
        this.getExamDetail();
        // console.log(this.typeid)
        //console.log(res.data.data.data1)
      } else {
        Toast(res.data.message);
      }
    },
    async getExamDetail(){
      if(!this.typeid==0){
        //console.log(this.list)
        const res = await API.getExamDetail({examid:this.examid,typeid:this.typeid,page:this.page,size:this.size});
        this.loading = false;
        if(res.data.code === 444){
          //console.log(res.data.data)
          window.location.href = res.data.data
        }else if (res.data.code === 200) {
          this.list.push(...res.data.data.list)
          // console.log(this.list.length,res.data.data.count,this.loading,this.page)
          if (this.list.length < res.data.data.count) {
          //console.log(2)
            this.page += 1;
          }else{
            this.finished = true;
          }
        } else {
          this.finished = true;
          Toast(res.data.message);
        }
      }
    },
    
    async checkTypetab(id,index){
      this.typeact=index;
      this.typesact=0;
      this.fid=id;
      this.list=[];
      console.log(this.fid)
      this.getInfosType(this.fid);
    },
   async checkTypestab(id,index){
      this.typesact=index;
      this.typeid=id;
      //console.log(this.examid);
      this.page=1;
      this.list=[];
      this.loading = true;
      this.finished = false;
      this.getExamDetail();
    },
    async remindcheck(){
      this.remindPop=true; 
    },
    async delremindcheck(){
      VanDialog.confirm({
          title: '提醒',
          message: '是否取消提醒？',
        })
        .then(() => {
          const params = {
            id: this.$route.params.id
          };
          const res = API.delCalendar(params);
          // console.log(1)
          Toast("取消提醒成功。");
          this.getExamInfo();
        })
        .catch(() => {
          // on cancel
        });
    },
    async remindChoose(v){
      const params = {
        id: this.$route.params.id,
        type: v.value
      };
      //console.log(params)
      const res = API.addCalendar(params);
      res.then(res=>{
            if(res.data.code !== 200){
            Toast(res.data.message);
          }else{
            this.remindChecked=true;
            this.remindPop=false; 
            Toast("开启提醒成功。");
            this.getExamInfo();
          }
        })
    },
    gotodetailinfo(id){
      //console.log(id);
      this.$router.push({ name: 'detailinfo', params: { id: id } });
    },
    imagePreview(data,indexs){
      //console.log(data.map(i=>i.url));
      const images=data.map((i)=>i.url)
      VanImagePreview({
        images:images,
        startPosition: indexs,
      });
    }
   
  }
};
</script>
<style rel="stylesheet/stylus" type="text/stylus" scoped>

</style>



// WEBPACK FOOTER //
// examdetail.vue?fc5503f4